import httpClient from './httpClient';

const ps_order_return = () => httpClient.get('/api/ps_order_return');
const add_order_return = (order_return) => httpClient.post('/api/ps_order_return',order_return);
const update_order_return = (id) => httpClient.put('/api/ps_order_return/'+id);
const delete_order_return = (order_return) => httpClient.delete('/api/ps_order_return/'+order_return.id);


export {
    ps_order_return,
    add_order_return,
    update_order_return,
    delete_order_return
}